import { useNavigate } from "react-router-dom";
import bgImg5 from "../../assets/images/communication/COMMUNICATION.webp";
import Hero from "../../Components/HeroIndustries/HeroIndustries";
import { ServiceCardView } from "../../Components/ServiceCardView";
const Index = () => {
  const navigate = useNavigate();
  return (
    <>
      <Hero
        pageName="SERVICES / DATA ENGINEERING AND GOVERNANCE"
        pageIntro="Deliver robust, scalable data solutions with advanced engineering for enterprise success."
        pageIntroPara={""}
        alt="img"
        image={bgImg5}
      />

      <ServiceCardView
        list={[
          {
            id: "data-platform",
            title: "Data Platform Engineering",
            desc: "Engineer scalable, high-performance data platforms integrating lakes, warehouses, and streaming systems for enterprise analytics.",
            technologies:
              "Databricks, Snowflake, BigQuery, Synapse, Kafka, Spark Streaming, Kubernetes",
            features: [
              "Petabyte-scale platforms",
              "Unified data lakes and warehouses",
              "Real-time streaming",
              "Kubernetes-based scalability",
            ],
            impact: "75% faster integration, 99.9% platform reliability",
            caseStudy: {
              client: "Global Retail Corporation",
              challenge:
                "Fragmented data systems limited scalability for global analytics.",
              solution:
                "NucleusTeq engineered a Databricks and Snowflake-based platform with Kafka streaming, unifying data for analytics.",
              outcome:
                "Reduced integration time by 70% and achieved 99.8% platform uptime.",
            },
            imagePrompt: {
              description:
                "A retail analytics dashboard showing unified data flows from lakes, warehouses, and streams, with Databricks and Snowflake icons. Use blue and white (#007BFF, #FFFFFF) for a modern design.",
              style: "Retail, data-driven, digital art, 800x400px",
              altText: "Retail dashboard with unified data platform",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "data-integration",
            title: "Advanced Data Integration & Pipeline Engineering",
            desc: "Design fault-tolerant, scalable pipelines for batch and real-time data integration, unifying diverse sources with optimized performance.",
            technologies:
              "Airflow, Talend, NiFi, AWS Glue, MuleSoft, SAP, Salesforce, Apache Spark",
            features: [
              "Batch and real-time pipelines",
              "Fault-tolerant design",
              "Scalable source unification",
              "Performance optimization",
            ],
            impact: "70% faster data processing, 25% reduced errors",
            caseStudy: {
              client: "Financial Institution",
              challenge:
                "Disparate systems and slow pipelines delayed transaction analytics.",
              solution:
                "NucleusTeq engineered Spark-based pipelines with Airflow and MuleSoft, unifying data for real-time analytics.",
              outcome: "Cut processing time by 65% and reduced errors by 20%.",
            },
            imagePrompt: {
              description:
                "A financial dashboard showing real-time transaction analytics and unified data flows, with Spark and Airflow icons. Use blue gradient (#E6F0FA to #007BFF) for a professional design.",
              style: "Financial, analytical, digital art, 800x400px",
              altText: "Financial dashboard with advanced data pipelines",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "security-governance",
            title: "Security & Governance Frameworks",
            desc: "Implement robust frameworks for data security, compliance, and governance, ensuring regulatory adherence and integrity.",
            technologies:
              "KMS, Key Vault, Collibra, Informatica Data Governance, Alation",
            features: [
              "End-to-end encryption",
              "Compliance automation",
              "Data lineage tracking",
              "Regulatory adherence",
            ],
            impact: "99.9% compliance, 20% reduced risk",
            caseStudy: {
              client: "Pharmaceutical Company",
              challenge:
                "Regulatory compliance with GDPR and FDA was critical for data operations.",
              solution:
                "NucleusTeq implemented Collibra and KMS for encryption, lineage tracking, and automated compliance.",
              outcome:
                "Achieved 100% GDPR/FDA compliance, reduced risks by 18%.",
            },
            imagePrompt: {
              description:
                "A pharmaceutical dashboard with compliance metrics, security, and lineage data, featuring Collibra icons. Use blue and white (#007BFF, #FFFFFF) for a secure design.",
              style: "Pharmaceutical, compliant, digital art, 800x400px",
              altText: "Pharmaceutical dashboard with security and governance",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "cloudops-dataops",
            title: "CloudOps & DataOps Automation",
            desc: "Automate cloud and data operations to streamline workflows, reduce overhead, and enhance enterprise efficiency.",
            technologies:
              "Terraform, CloudFormation, Airflow, Jenkins, Kubernetes, Oozie",
            features: [
              "Infrastructure automation",
              "Workflow orchestration",
              "Scalable operations",
              "Efficiency audits",
            ],
            impact: "60% reduced overhead, 40% faster operations",
            caseStudy: {
              client: "Telecom Operator",
              challenge:
                "Manual operations increased costs and slowed data workflows.",
              solution:
                "NucleusTeq deployed Terraform and Airflow for automated CloudOps and DataOps, optimizing enterprise workflows.",
              outcome: "Reduced overhead by 55% and sped up operations by 35%.",
            },
            imagePrompt: {
              description:
                "A telecom control room with a dashboard showing automated CloudOps and DataOps workflows, with Terraform icons. Use blue gradient (#E6F0FA to #007BFF) for a high-tech look.",
              style: "Telecom, futuristic, digital art, 800x400px",
              altText: "Telecom dashboard with automated CloudOps and DataOps",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "observability-optimization",
            title: "Pipeline Observability & Optimization",
            desc: "Enable real-time pipeline monitoring, anomaly detection, and performance optimization for complete visibility and reliability.",
            technologies:
              "Prometheus, Grafana, Elasticsearch, Kibana, Datadog, Splunk",
            features: [
              "Real-time monitoring",
              "Anomaly detection",
              "Performance tuning",
              "Interactive visualizations",
            ],
            impact: "100% visibility, 50% faster issue resolution",
            caseStudy: {
              client: "Financial Services Provider",
              challenge: "Lack of pipeline visibility delayed issue detection.",
              solution:
                "NucleusTeq implemented Prometheus and Grafana for real-time observability and optimization of financial pipelines.",
              outcome:
                "Achieved 100% visibility and reduced issue resolution time by 45%.",
            },
            imagePrompt: {
              description:
                "A financial dashboard with pipeline monitoring, anomaly alerts, and optimization metrics, featuring Prometheus icons. Use blue gradient (#E6F0FA to #007BFF) for a data-driven design.",
              style: "Financial, analytical, digital art, 800x400px",
              altText:
                "Financial dashboard with pipeline observability and optimization",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "data-quality",
            title: "Data Quality Engineering",
            desc: "Engineer automated data quality solutions with validation, anomaly detection, and testing to ensure enterprise-grade reliability.",
            technologies:
              "Great Expectations, Deequ, TensorFlow, PyTorch, Apache Griffin",
            features: [
              "Automated validation",
              "ML-based anomaly detection",
              "Quality testing frameworks",
              "Data integrity assurance",
            ],
            impact: "99.9% data accuracy, 30% reduced errors",
            caseStudy: {
              client: "Healthcare Organization",
              challenge:
                "Data errors in patient records risked analytics reliability.",
              solution:
                "NucleusTeq engineered a Great Expectations and Deequ-based quality solution, automating validation in patient data pipelines.",
              outcome:
                "Achieved 99.9% data accuracy and reduced errors by 25%.",
            },
            imagePrompt: {
              description:
                "A healthcare dashboard with patient data quality metrics and validation results, featuring Great Expectations icons. Use blue gradient (#E6F0FA to #007BFF) for a secure look.",
              style: "Healthcare, analytical, digital art, 800x400px",
              altText: "Healthcare dashboard with data quality engineering",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "scalable-pipeline",
            title: "Scalable Data Pipeline Architecture",
            desc: "Design scalable pipeline architectures to handle high data volumes with fault tolerance and optimized performance.",
            technologies: "Apache Spark, Kubernetes",
            features: [
              "Scalable pipeline design",
              "High-load performance",
              "Fault-tolerant architectures",
              "Volume optimization",
            ],
            impact: "60% improved scalability, 25% reduced latency",
            caseStudy: {
              client: "Global Logistics Firm",
              challenge:
                "Growing shipment data volumes strained pipeline scalability.",
              solution:
                "NucleusTeq designed Spark-based scalable pipelines with Kubernetes, ensuring high performance under load.",
              outcome:
                "Improved scalability by 55% and reduced latency by 20%.",
            },
            imagePrompt: {
              description:
                "A logistics dashboard showing scalable pipeline metrics and shipment data flows, with Spark and Kubernetes icons. Use blue gradient (#E6F0FA to #007BFF) for a technical design.",
              style: "Logistics, technical, digital art, 800x400px",
              altText: "Logistics dashboard with scalable data pipelines",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "pipeline-security",
            title: "Data Pipeline Security",
            desc: "Implement advanced security measures to protect data pipelines from threats and ensure compliance.",
            technologies: "KMS, Key Vault",
            features: [
              "Pipeline encryption",
              "Access controls",
              "Threat detection",
              "Compliance integration",
            ],
            impact: "99.9% pipeline security, 25% reduced vulnerabilities",
            caseStudy: {
              client: "Banking Institution",
              challenge:
                "Pipeline vulnerabilities risked sensitive transaction data.",
              solution:
                "NucleusTeq deployed KMS for pipeline encryption and secure access controls, ensuring data protection.",
              outcome:
                "Achieved 99.9% pipeline security and reduced vulnerabilities by 22%.",
            },
            imagePrompt: {
              description:
                "A banking dashboard showing pipeline security metrics and encryption status, with KMS icons. Use blue gradient (#E6F0FA to #007BFF) for a secure design.",
              style: "Banking, secure, digital art, 800x400px",
              altText: "Banking dashboard with pipeline security measures",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "real-time-analytics",
            title: "Real-Time Analytics Enablement",
            desc: "Enable real-time analytics with streaming pipelines for dynamic, low-latency insights.",
            technologies: "Kafka, Spark Streaming",
            features: [
              "Real-time data processing",
              "Low-latency analytics",
              "Scalable streaming",
              "Dynamic insights",
            ],
            impact: "70% faster analytics, 20% reduced latency",
            caseStudy: {
              client: "Retail Company",
              challenge:
                "Delayed customer analytics impacted real-time personalization.",
              solution:
                "NucleusTeq implemented Kafka-based streaming pipelines for real-time customer analytics.",
              outcome:
                "Reduced analytics latency by 65% and improved personalization by 18%.",
            },
            imagePrompt: {
              description:
                "A retail dashboard showing real-time customer analytics and streaming data flows, with Kafka icons. Use blue and white (#007BFF, #FFFFFF) for a modern design.",
              style: "Retail, data-driven, digital art, 800x400px",
              altText: "Retail dashboard with real-time analytics",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "data-lake-optimization",
            title: "Data Lake Optimization",
            desc: "Optimize data lakes for performance, cost efficiency, and advanced analytics integration.",
            technologies: "Databricks, Snowflake",
            features: [
              "Performance tuning",
              "Cost-efficient storage",
              "Analytics integration",
              "Scalable lakes",
            ],
            impact: "50% faster data access, 30% reduced costs",
            caseStudy: {
              client: "E-commerce Platform",
              challenge: "Inefficient data lake performance slowed analytics.",
              solution:
                "NucleusTeq optimized a Snowflake-based data lake, tuning performance and integrating analytics.",
              outcome: "Cut data access time by 45% and reduced costs by 25%.",
            },
            imagePrompt: {
              description:
                "An e-commerce dashboard showing optimized data lake performance and analytics, with Snowflake icons. Use blue gradient (#E6F0FA to #007BFF) for a clean look.",
              style: "E-commerce, analytical, digital art, 800x400px",
              altText: "E-commerce dashboard with optimized data lake",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "data-warehouse-analytics",
            title: "Data Warehouse Analytics",
            desc: "Enhance data warehouses for high-speed querying and advanced analytics to support enterprise reporting.",
            technologies: "BigQuery, Synapse",
            features: [
              "High-speed querying",
              "Advanced analytics",
              "Scalable storage",
              "Reporting integration",
            ],
            impact: "60% faster reporting, 25% improved analytics",
            caseStudy: {
              client: "Financial Services Firm",
              challenge: "Slow warehouse queries delayed financial reporting.",
              solution:
                "NucleusTeq enhanced a BigQuery warehouse, optimizing queries for advanced financial analytics.",
              outcome:
                "Reduced reporting time by 55% and improved analytics by 20%.",
            },
            imagePrompt: {
              description:
                "A financial dashboard with high-speed query results and analytics, featuring BigQuery icons. Use blue and white (#007BFF, #FFFFFF) for a professional design.",
              style: "Financial, data-centric, digital art, 800x400px",
              altText: "Financial dashboard with data warehouse analytics",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "compliance-monitoring",
            title: "Compliance Monitoring",
            desc: "Automate real-time compliance monitoring to ensure continuous regulatory adherence with minimal effort.",
            technologies: "Informatica Data Governance",
            features: [
              "Real-time compliance checks",
              "Automated monitoring",
              "Audit reporting",
              "Regulatory adherence",
            ],
            impact: "99.9% compliance, 30% reduced audit time",
            caseStudy: {
              client: "Insurance Provider",
              challenge:
                "Manual compliance monitoring increased audit efforts.",
              solution:
                "NucleusTeq deployed Informatica for real-time compliance monitoring and automated audit reporting.",
              outcome:
                "Reduced audit time by 28% and achieved 100% compliance.",
            },
            imagePrompt: {
              description:
                "An insurance dashboard with real-time compliance metrics and audit reports, featuring Informatica icons. Use blue gradient (#E6F0FA to #007BFF) for a professional look.",
              style: "Insurance, compliant, digital art, 800x400px",
              altText: "Insurance dashboard with compliance monitoring",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
          {
            id: "dataops-visualization",
            title: "Observability",
            desc: "Develop end-to-end monitoring, alerting & interactive visualization dashboards for DataOps & Data Ops insights, enhancing pipeline management and decision-making.",
            technologies: "Datadog, Splunk",
            features: [
              "Interactive dashboards",
              "Real-time insights",
              "Custom visualizations",
              "Pipeline management",
            ],
            impact: "50% faster insights, 30% improved visibility",
            caseStudy: {
              client: "Telecom Provider",
              challenge:
                "Limited DataOps visibility slowed pipeline management.",
              solution:
                "NucleusTeq developed Datadog-based visualization dashboards for real-time DataOps insights.",
              outcome:
                "Improved insight delivery by 45% and enhanced visibility by 28%.",
            },
            imagePrompt: {
              description:
                "A telecom dashboard with DataOps visualization metrics and pipeline insights, featuring Datadog icons. Use blue and white (#007BFF, #FFFFFF) for a modern design.",
              style: "Telecom, data-driven, digital art, 800x400px",
              altText: "Telecom dashboard with DataOps visualization",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },

          {
            id: "operational-performance",
            title: "Operational Performance Consulting",
            desc: "Optimize data operations through performance audits and advanced analytics to drive efficiency and cost savings.",
            technologies: "Audit frameworks, operational analytics",
            features: [
              "Performance audits",
              "Cost optimization",
              "Process streamlining",
              "Analytics-driven insights",
            ],
            impact: "40% reduced overhead, 30% faster processes",
            caseStudy: {
              client: "Manufacturing Company",
              challenge: "Inefficient data operations increased costs.",
              solution:
                "NucleusTeq conducted performance audits, using analytics to optimize data operations.",
              outcome: "Reduced overhead by 35% and sped up processes by 28%.",
            },
            imagePrompt: {
              description:
                "A manufacturing dashboard with operational performance metrics and audit results. Use blue and white (#007BFF, #FFFFFF) for a professional look.",
              style: "Manufacturing, analytical, digital art, 800x400px",
              altText:
                "Manufacturing dashboard with operational performance metrics",
            },
            buttunData: {
              buttonText: "Strengthen Your Data Foundation",
              buttonAction: () => {
                navigate("/contact");
              },
            },
          },
        ]}
        buttunData={{
          buttonText: "Explore Solutions",
          buttonAction: () => {
            navigate("/contact");
          },
        }}
      />
    </>
  );
};

export default Index;
